import React, { useEffect, useState } from "react";
import { useParams, useLocation, Redirect } from "react-router-dom";

import CustomizeStandardPage from "../CustomizeStandardPage";
import CustomizeStandingPage from "../CustomizeStandingPage";
import CustomizeBanner from "../CustomizeBanner";

import { useFeedItem } from "../../Shared/FeedItem/useFeedItem";
import { mapApiResponseToFeedItem } from "../../utils/mapFeedItems";
import Loader from "shared/Loader";
import {
  useFeedItemOptionsDropdown,
  useFeedItemOptionsDropdownGroup,
} from "NewsAdmin/Shared/FeedItemOptionsDropdown/useFeedItemOptionsDropdown";
import NotificationOverlay from "NewsAdmin/Shared/NotificationOverlay";

export function EditFeedPage() {
  const { id } = useParams(); // Pull ID from the URL
  const location = useLocation();
  const pageType = location.state?.pageType || "Standard Content"; // fallback if missing
  const isCloning = location.state?.isCloning || false;
  const { data: diamondsList, isLoading: isLoadingDiamonds } =
    useFeedItemOptionsDropdown();
  const { data: groupsList, isLoading: isLoadingGroups } =
    useFeedItemOptionsDropdownGroup();
  const justAdded = location.state?.justAdded || false;

  // console.log(id, pageType);
  const { data, isLoading, isFetching, isError } = useFeedItem(id); // ID dependency correctly passed
  const mappedItem = data && diamondsList && groupsList ? mapApiResponseToFeedItem(data, diamondsList, groupsList) : null;

  const [showAlert, setShowAlert] = useState(false);
  const [justCreated, setJustCreated] = useState(justAdded);
  useEffect(() => {
    if (!justCreated) return;

    setShowAlert(true);

    const timer = setTimeout(() => {
      setShowAlert(false);
      setJustCreated(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [justCreated]);

  // Debugging -- Ignore
  // console.log("EditFeedPage id:", id);
  // console.log("EditFeedPage mappedItem:", mappedItem);

  // Item doesn't exist (or failed to load) — send the user back to the feed
  if (isError) {
    return <Redirect to="/marketing/news/feed" />;
  }

  if (isLoading || isFetching || isLoadingDiamonds || isLoadingGroups) {
    return <Loader />;
  }

  return (
    <>
      <NotificationOverlay
        isVisible={showAlert}
        overlayText="Feed Item Added"
      />

      {pageType === "Standard Content" && (
        <CustomizeStandardPage
          isNew={false}
          feedItem={mappedItem}
          feedItemId={id}
          isCloning={isCloning}
          justAdded={justAdded}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
      {pageType === "Standing Order" && (
        <CustomizeStandingPage
          isNew={false}
          feedItem={mappedItem}
          feedItemId={id}
          isCloning={isCloning}
          justAdded={justAdded}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
      {pageType === "Banner" && (
        <CustomizeBanner
          isNew={false}
          feedItem={mappedItem}
          feedItemId={id}
          isCloning={isCloning}
          justAdded={justAdded}
          diamondsList={diamondsList}
          groupsList={groupsList}
        />
      )}
    </>
  );
}
